import './Loading.scss'

const Loading = ({ className }) => {
  return (
    <div className={`ds-loading ${className}`}>
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.16" fill-rule="evenodd" clip-rule="evenodd" d="M8.5 2.52612C5.482 2.52612 3.026 4.98212 3.026 8.00012C3.026 11.0181 5.482 13.4731 8.5 13.4731C11.518 13.4731 13.974 11.0181 13.974 8.00012C13.974 4.98212 11.518 2.52612 8.5 2.52612ZM8.5 16.0001C4.089 16.0001 0.5 12.4111 0.5 8.00012C0.5 3.58812 4.089 0.00012207 8.5 0.00012207C12.911 0.00012207 16.5 3.58812 16.5 8.00012C16.5 12.4111 12.911 16.0001 8.5 16.0001Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2368 9.26291C14.5388 9.26291 13.9738 8.69791 13.9738 7.99991C13.9738 4.98191 11.5178 2.52591 8.4998 2.52591C7.8018 2.52591 7.2368 1.96091 7.2368 1.26291C7.2368 0.564908 7.8018 -9.15527e-05 8.4998 -9.15527e-05C12.9108 -9.15527e-05 16.4998 3.58891 16.4998 7.99991C16.4998 8.69791 15.9348 9.26291 15.2368 9.26291Z"/>
      </svg>
    </div>
  )
}

export default Loading